module.exports = __webpack_public_path__ + "img/bj_right.92bb9c0b.png";